import templateUrl from "emun.order/tracking/tracking-info.htm";
import controller from "emun.order/tracking/tracking-info.controller";

export default {
	bindings: {
		trackingNumber: "@",
		carrier: "@"
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

